import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (keyword.trim()) {
      navigate(`/search?q=${encodeURIComponent(keyword.trim())}`);
      setMobileOpen(false);
    }
  };

  const navLinks = [
    { label: '首页', to: '/' },
    { label: '影视分类', to: '/category' },
    { label: '资讯', to: '/news' },
    { label: '关于我们', to: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
          <span
            className={`font-heading text-xl md:text-2xl font-bold tracking-wide ${
              scrolled ? 'text-primary-700' : 'text-background-50'
            }`}
          >
            泰坦尼克号
          </span>
          <span className={`hidden sm:inline text-xs tracking-[0.3em] uppercase ${scrolled ? 'text-accent-700' : 'text-accent-300'}`}>
            影视档案馆
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium cursor-pointer whitespace-nowrap transition-colors ${
                scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-50 hover:text-accent-300'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:block">
          <form onSubmit={handleSearch} className="relative">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视或资讯"
              className={`w-56 lg:w-64 text-sm rounded-full pl-4 pr-10 py-2 border outline-none transition-colors ${
                scrolled
                  ? 'bg-background-100 border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:border-primary-400'
                  : 'bg-background-50/15 border-background-50/40 text-background-50 placeholder:text-background-100/80 focus:border-accent-300'
              }`}
            />
            <button
              type="submit"
              aria-label="搜索"
              className={`absolute right-1 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full cursor-pointer ${
                scrolled ? 'text-primary-600' : 'text-background-50'
              }`}
            >
              <i className="ri-search-line"></i>
            </button>
          </form>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? 'text-foreground-800' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 space-y-4">
          <form onSubmit={handleSearch} className="relative">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视或资讯"
              className="w-full text-sm rounded-full pl-4 pr-10 py-2 border border-background-300 bg-background-100 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="absolute right-1 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full text-primary-600 cursor-pointer"
            >
              <i className="ri-search-line"></i>
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium text-foreground-700 py-2 px-2 rounded-md hover:bg-background-100 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}